import OpenSansText from "components/custom-texts/open-sans-text";

export const LineBreak = () => {
  return <hr style={{ margin: 5 }} />;
};

const CONTENT = [`Safari`, `Chrome`, `Firefox`, `Edge`, `Samsung Internet for Android`];

const SupportedBrowsers = () => {
  return (
    <>
      {CONTENT.map((string, index) => {
        const isLast = index === CONTENT.length - 1;
        return (
          <div style={{ paddingLeft: 10, paddingRight: 10 }} key={index}>
            <OpenSansText>{string}</OpenSansText>
            {!isLast && <LineBreak />}
          </div>
        );
      })}
    </>
  );
};

export default SupportedBrowsers;
